import { ifCampaignOrAppointment } from '../utils/authorization.js';

export default [
    {
        path: '/imports',
        name: 'imports',
        component: () => import(/* webpackChunkName: "imports" */ '../views/Imports/ImportList.vue'),
        beforeEnter: ifCampaignOrAppointment,
        meta: {
            title: 'appointments.importHistory.pageTitle',
        },
    },
    {
        path: '/imports/:id',
        name: 'appointments.import.result',
        component: () => import(/* webpackChunkName: "appointments-import" */ '../views/Appointments/ImportResultList.vue'),
        meta: {
            title: 'appointments.importResult.pageTitle',
            mayChangeAccount: false,
        },
    },
];
